import styled from '@emotion/styled';
import { Button as HotsauceButton, Stack, Text, tokens } from '@hotjar/hotsauce';
import type { IconName } from '@hotjar/hotsauce';

const Wrapper = styled.div`
  flex: 6;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${tokens.spacer.x2};
  padding: ${tokens.spacer.x2};
  border-radius: ${tokens.radius.l};
  background-color: ${tokens.color.bg_info};
`;

const Button = styled(HotsauceButton)`
  width: fit-content;
`;

type Props = {
  title: string;
  description: string;
  link: string;
  href: string;
  icon: IconName;
  onCtaClick: () => void;
};

export function CallToAction({
  title,
  description,
  link,
  href,
  icon,
  onCtaClick,
}: Props): JSX.Element {
  return (
    <Wrapper>
      <Stack direction="column" customSpacing={tokens.spacer.x1}>
        <Text textType="subtitle2">{title}</Text>
        <Text textType="body2" textColor="text_light">
          {description}
        </Text>
      </Stack>
      <Button
        as="a"
        icon={icon}
        kind="secondary"
        href={href}
        size="s"
        isExternal
        onClick={onCtaClick}
      >
        {link}
      </Button>
    </Wrapper>
  );
}
